import _ from 'lodash'
import { FC } from 'react'
import { connectCurrentRefinements } from 'react-instantsearch-dom'

interface props {
  items: any[]
  hideIfZero: boolean
  // Active toggle filters (Clearance / Special Offers) applied via Configure,
  // which connectCurrentRefinements can't see. Added to the badge total.
  extraCount?: number
}
const CurrentRefinements: FC<props> = ({
  items,
  hideIfZero = false,
  extraCount = 0,
}) => {
  //Need to figure out why items return same item four times
  //Use lodash to get unique result for now
  const uniqueCurrentRefinmentsObject = _.uniqBy(items, 'id')
  let numberOfFilters = 0
  uniqueCurrentRefinmentsObject.forEach((element) => {
    numberOfFilters += element.items.length
  })
  const total = numberOfFilters + extraCount
  if (hideIfZero && total === 0) return <></>
  return (
    <>
      <div className="mr-3 flex items-center justify-center rounded-full text-white text-label h-6 w-6 bg-brand-chrome">
        {total}
      </div>
    </>
  )
}

const NoOfFilters = connectCurrentRefinements(CurrentRefinements)
export default NoOfFilters
